import { render, staticRenderFns } from "./LongAnswer.vue?vue&type=template&id=0810311d&"
import script from "./LongAnswer.vue?vue&type=script&lang=js&"
export * from "./LongAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports